/* eslint-disable */
import React, { useState, useEffect, Fragment } from 'react';
import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';
import Page from '../../../../Page';
import { LoadingButton } from '@material-ui/lab';
import {
    Card,
    Grid,
    TextField,
    Container,
    Tooltip,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Stack,
    ButtonGroup
} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import services from '../../Service';
import { ToastContainer, toast } from 'react-toastify';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import ArrowForwardIosOutlinedIcon from '@material-ui/icons/ArrowForwardIosOutlined';
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import { AlertDialog } from '../../../Common/AlertDialog';
import MenuItem from '@material-ui/core/MenuItem';

var screenCode = "FARMER"

export function SupplierProduce({ handleNext, handleBack, farmerId }) {
    const [message, setMessage] = useState("Delete Confirmation");
    const [EnableConfirmMessage, setEnableConfirmMessage] = useState(false);
    const [farmerSupplierProduceID, setFarmerSupplierProduceID] = useState();
    const [SupplierProduceArray, setSupplierProduceArray] = useState([]);
    const [groupFactory, setGroupFactory] = useState([]);
    const [factoryType, setFactoryType] = useState(0);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const [pageProps, setPageProps] = useState({
        editingID: 0,
        Edit: false,
        submitButtonName: "Add",
        pageheadername: "Add Supplier Produce details"
    });

    const [formData, setFormData] = useState({
        SeasonalSupplier: 0,
        BrandOfSuppliedID: 0,
        BuyersOfAgriProduceType: 0,
        BuyOther: '',
        Transportation: 0,
        TransOther: '',
        TypeOfTheVehicle: 0,
        TypeOfTheVehicleOther: '',
        VehicalNumber: '',
        LabourType: '0',
        OtherLabourType: '',
        nameOfEntity: ''
    });

    const SupplierProduceSaveSchema = Yup.object().shape({
        // SeasonalSupplier: Yup.number().min(1, 'Is The Farner Seasonal Supplier required').required('Is The Farner Seasonal Supplier required'),
        BrandOfSuppliedID: Yup.number().min(1, 'Brands Supplied required').required('Brands Supplied required'),
        BuyersOfAgriProduceType: Yup.number().min(1, 'Other Buyers of Agri Produce is Required').required('Other Buyers of Agri Produce is Required'),
        BuyOther: Yup.string().when('BuyersOfAgriProduceType', { is: (BuyersOfAgriProduceType) => BuyersOfAgriProduceType == 4, then: Yup.string().required('Other is Required'), otherwise: Yup.string().nullable(), }),
        Transportation: Yup.number().min(1, 'Transportation is Required').required('Transportation Required'),
        TransOther: Yup.string().when('Transportation', { is: (Transportation) => Transportation == 3, then: Yup.string().required('Other Transportation is Required'), otherwise: Yup.string().nullable(), }),
        //TypeOfTheVehicle: Yup.number().min(1, 'Type Of The Vehicle is Required').required('Type Of The Vehicleis Required'),
        //TypeOfTheVehicleOther: Yup.string().when('TypeOfTheVehicle', { is: (TypeOfTheVehicle) => TypeOfTheVehicle == 9, then: Yup.string().required('Other Type of Vehicle is Required'), otherwise: Yup.string().nullable(), }),
        //VehicalNumber: Yup.string().matches(/^((?!0000)([a-zA-Z]{1,3}|([0-9]{1,3}))-[0-9])|(([a-zA-Z]{1,3}|([0-9]{1,3}))-[0-9])(?!000)$/, 'Please enter valid Vehicle Number with (-) ').required('Vehicle Number required'),
        LabourType: Yup.number().min(1, 'Please Select Labour Used').required('Labour Used Required'),
        OtherLabourType: Yup.string().when('LabourType', { is: (LabourType) => LabourType == 4, then: Yup.string().required('Other Labour Used is Required'), otherwise: Yup.string().nullable(), }),
        nameOfEntity: Yup.string().required('Name of Entity is Required')
    });

    const formik = useFormik({
        initialValues: {
            SeasonalSupplier: formData.SeasonalSupplier,
            BrandOfSuppliedID: formData.BrandOfSuppliedID,
            BuyersOfAgriProduceType: formData.BuyersOfAgriProduceType,
            BuyOther: formData.BuyOther,
            Transportation: formData.Transportation,
            TransOther: formData.TransOther,
            //TypeOfTheVehicle: formData.TypeOfTheVehicle,
            //TypeOfTheVehicleOther: formData.TypeOfTheVehicleOther,
            //VehicalNumber: formData.VehicalNumber,
            LabourType: formData.LabourType,
            OtherLabourType: formData.OtherLabourType,
            nameOfEntity: formData.nameOfEntity,
        },

        validationSchema: SupplierProduceSaveSchema,
        onSubmit: (values) => {
            addGrid(values);
        },
        enableReinitialize: true
    });
    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    useEffect(() => {
        trackPromise(
            GetFarmerSupplierProduceByFarmerID());
    }, []);

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        if (formik.values.BuyersOfAgriProduceType != 4) {
            setValues({
                ...values,
                BuyOther: ""
            })
        }
    }, [formik.values.BuyersOfAgriProduceType]);



    useEffect(() => {
        if (formik.values.Transportation != 3) {
            setValues({
                ...values,
                TransOther: ""
            })
        }
    }, [formik.values.Transportation]);


    useEffect(() => {
        if (formik.values.TypeOfTheVehicle != 9) {
            setValues({
                ...values,
                TypeOfTheVehicleOther: ""
            })
        }
    }, [formik.values.TypeOfTheVehicle]);


    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFARMER');

        if (isAuthorized === undefined) {
            navigate('/404');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });
        setGroupFactory({
            ...groupFactory,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
        })
        setFactoryType(parseInt(TokenDecoder.getFactoryTypeFromToken()))


    }

    async function addGrid(values) {
        if (pageProps.Edit != true) {
            let sampleSupplierProduce = {
                farmerSupplierProduceID: parseInt(0),
                farmerID: parseInt(farmerId),
                createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
                seasonalSupplier: parseInt(0),
                brandOfSupplied: parseInt(values.BrandOfSuppliedID),
                buyersOfAgriProduceType: parseInt(values.BuyersOfAgriProduceType),
                transportation: parseInt(values.Transportation),
                typeOfTheVehicle: parseInt(0),
                buyOther: values.BuyOther == null ? '' : values.BuyOther,
                transother: values.TransOther == null ? '' : values.TransOther,
                typeOfTheVehicleOther: "",
                vehicalNumber: "",
                labourType: parseInt(values.LabourType),
                otherLabourType: values.OtherLabourType == null ? '' : values.OtherLabourType,
                nameOfEntity: values.nameOfEntity
            };
            const res = await services.SaveFarmerSupplierProduceDetail(sampleSupplierProduce);
            if (res.statusCode == 'Success') {
                toast.success("Supplier Produce Details Saved Succesfully");
                trackPromise(GetFarmerSupplierProduceByFarmerID(farmerId));
                clearAll();
            } else {
                toast.error("Error occured in Farmer Supplier Produce Details.");
            }
        }
        else {
            let updateSupplierProduce = {
                farmerSupplierProduceID: parseInt(pageProps.editingID),
                farmerID: parseInt(farmerId),
                createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
                seasonalSupplier: parseInt(0),
                brandOfSupplied: parseInt(values.BrandOfSuppliedID),
                buyersOfAgriProduceType: parseInt(values.BuyersOfAgriProduceType),
                transportation: parseInt(values.Transportation),
                typeOfTheVehicle: parseInt(0),
                buyOther: values.BuyOther == null ? '' : values.BuyOther,
                transother: values.TransOther == null || values.TransOther == undefined ? '' : values.TransOther,
                typeOfTheVehicleOther: "",
                vehicalNumber: "",
                labourType: parseInt(values.LabourType),
                otherLabourType: values.OtherLabourType,
                nameOfEntity: values.nameOfEntity
            };
            const res = await services.UpdateFarmerSupplierProduceDetail(updateSupplierProduce);
            if (res.statusCode == 'Success') {
                toast.success("Supplier Produce Details Updated Succesfully");
                trackPromise(GetFarmerSupplierProduceByFarmerID(farmerId));
                setPageProps({
                    ...pageProps,
                    editingID: 0,
                    Edit: false,
                    submitButtonName: "Add",
                })
                clearAll();
            } else {
                toast.error("Error occured in Farmer Supplier Produce Details.");
            }
        }
    }

    async function GetFarmerSupplierProduceByFarmerID() {
        var res = await services.GetFarmerSupplierProduceByFarmerID(farmerId);
        if (res.statusCode === "Success") {
            setSupplierProduceArray(res.data);
        }
    }

    async function DeleteItem(index) {
        if (SupplierProduceArray[index].farmerSupplierProduceID !== undefined) {
            const res = await services.DeleteFarmerSupplierProduceDetail(SupplierProduceArray[index].farmerSupplierProduceID);
            var result = SupplierProduceArray.filter((img, i) => i !== index);

            setSupplierProduceArray(result);

            if (res.data === 1) {
                toast.success('Supplier Produce Details Deleted Successfully');
            } else {
                toast.error('Error occured in Supplier Produce Details delete');
            }

        } else {
            var result = SupplierProduceArray.filter((x, i) => i !== index);
            setSupplierProduceArray(result);
            toast.success('Supplier Produce Details Deleted Successfully');
        }
    }

    async function clearAll() {
        formik.resetForm();
    }

    function confirmData(y) {
        if (y) {
            DeleteItem(farmerSupplierProduceID);
        }
    }

    function handleConfirm(data) {
        setFarmerSupplierProduceID(data);
        setEnableConfirmMessage(true);
    }

    function handleEdit(rowData, index) {
        var array = [...SupplierProduceArray];
        setValues({
            ...values,
            SeasonalSupplier: rowData.seasonalSupplier,
            BrandOfSuppliedID: rowData.brandOfSupplied,
            BuyersOfAgriProduceType: rowData.buyersOfAgriProduceType,
            Transportation: rowData.transportation,
            //TypeOfTheVehicle: rowData.typeOfTheVehicle,
            BuyOther: rowData.buyOther,
            TransOther: rowData.transother,
            //TypeOfTheVehicleOther: rowData.typeOfTheVehicleOther,
            //VehicalNumber: rowData.vehicalNumber == '' ? '' : rowData.vehicalNumber,
            LabourType: rowData.labourType,
            OtherLabourType: rowData.otherLabourType,
            nameOfEntity: rowData.nameOfEntity == null ? '' : rowData.nameOfEntity,
        })
        array.splice(index, 1);
        setPageProps({
            ...pageProps,
            editingID: rowData.farmerSupplierProduceID,
            Edit: true,
            submitButtonName: "Update",
        })
        setSupplierProduceArray(array);

    }

    return (
        <>
            <LoadingComponent />
            <Page title="Supplier Produce Details  |  FAPS">
                <Container>
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate onSubmit={handleSubmit}
                        >
                            <Card style={{ justifycontent: 'center' }} >
                                <Stack spacing={2} margin={3}>
                                    <Typography variant="h6">{(factoryType == 1 || factoryType == 3) ? "View SupplierProduce Details" : "Supplier Produce Details"}
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                            <ButtonGroup disableElevation variant="outlined" color="primary">
                                                <Tooltip title="Contact Person">
                                                    <IconButton
                                                        variant="outlined"
                                                        color="secondary"
                                                        onClick={handleBack}
                                                    >
                                                        <ArrowBackIosOutlinedIcon />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title=" Business">
                                                    <IconButton
                                                        variant="outlined"
                                                        color="secondary"
                                                        onClick={handleNext}
                                                    >
                                                        <ArrowForwardIosOutlinedIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </ButtonGroup>
                                        </Stack>
                                    </Typography>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        {/* <Stack width={350}>
                                            <TextField select
                                                fullWidth
                                                size="small"
                                                label=" Seasonal Supplier Type *"
                                                value={formik.values.SeasonalSupplier}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('SeasonalSupplier')}
                                                error={Boolean(touched.SeasonalSupplier && errors.SeasonalSupplier)}
                                                helperText={touched.SeasonalSupplier && errors.SeasonalSupplier}
                                                disabled={factoryType == 1 || factoryType == 3}
                                            >
                                                <MenuItem key={0} value={0}> Select Seasonal Supplier Type</MenuItem>
                                                <MenuItem value={1}> Yes</MenuItem>
                                                <MenuItem value={2}> No</MenuItem>
                                            </TextField>
                                        </Stack> */}
                                        <Stack width={350}>
                                            <TextField select
                                                fullWidth
                                                size="small"
                                                label="Brands Supplied *"
                                                value={formik.values.BrandOfSuppliedID}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('BrandOfSuppliedID')}
                                                error={Boolean(touched.BrandOfSuppliedID && errors.BrandOfSuppliedID)}
                                                helperText={touched.BrandOfSuppliedID && errors.BrandOfSuppliedID}
                                                disabled={factoryType == 1 || factoryType == 3}
                                            >
                                                <MenuItem key={0} value={0}> Select Brands Supplied</MenuItem>
                                                <MenuItem value={1}> Good Harvest</MenuItem>
                                                <MenuItem value={2}> Bee Safe</MenuItem>
                                                <MenuItem value={3}> Normal</MenuItem>
                                            </TextField>
                                        </Stack>
                                        <Stack width={350}>
                                            <TextField select
                                                fullWidth
                                                size="small"
                                                label="Other Buyers of Agri Produce *"
                                                value={formik.values.BuyersOfAgriProduceType}
                                                onChange={(event) => {
                                                    formik.handleChange(event);
                                                    // Check if the selected value is 'Other' to enable/disable the other text field
                                                    if (event.target.value === 4) {
                                                        formik.setFieldValue('Buyother', '');
                                                    }
                                                }}
                                                {...getFieldProps('BuyersOfAgriProduceType')}
                                                error={Boolean(touched.BuyersOfAgriProduceType && errors.BuyersOfAgriProduceType)}
                                                helperText={touched.BuyersOfAgriProduceType && errors.BuyersOfAgriProduceType}
                                                disabled={factoryType == 1 || factoryType == 3}
                                            >
                                                <MenuItem key={0} value={0}> Select Other Buyers of Agri Produce</MenuItem>
                                                <MenuItem value={1}> Wet Market</MenuItem>
                                                <MenuItem value={2}> Exporter</MenuItem>
                                                <MenuItem value={3}> Other Super Markets</MenuItem>
                                                <MenuItem value={4}> Other</MenuItem>
                                            </TextField>
                                        </Stack>
                                        <Stack width={350}>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Other *"
                                                value={formik.values.BuyOther}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('BuyOther')}
                                                error={Boolean(touched.BuyOther && errors.BuyOther)}
                                                helperText={touched.BuyOther && errors.BuyOther}
                                                disabled={factoryType == 1 || factoryType == 3 || formik.values.BuyersOfAgriProduceType !== 4}
                                            />
                                        </Stack>
                                    </Stack>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            label="Name of Entity *"
                                            value={formik.values.nameOfEntity}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('nameOfEntity')}
                                            error={Boolean(touched.nameOfEntity && errors.nameOfEntity)}
                                            helperText={touched.nameOfEntity && errors.nameOfEntity}
                                            disabled={factoryType == 1 || factoryType == 3}
                                        />
                                        <TextField select
                                            fullWidth
                                            size="small"
                                            label="Transportation of Produce *"
                                            value={formik.values.Transportation}
                                            onChange={(event) => {
                                                formik.handleChange(event);
                                                // Check if the selected value is 'Other' to enable/disable the other text field
                                                if (event.target.value === 3) {
                                                    formik.setFieldValue('TransOther', '');
                                                }
                                            }}
                                            {...getFieldProps('Transportation')}
                                            error={Boolean(touched.Transportation && errors.Transportation)}
                                            helperText={touched.Transportation && errors.Transportation}
                                            disabled={factoryType == 1 || factoryType == 3}
                                        >
                                            <MenuItem key={0} value={0}> Select Transportation of Produce</MenuItem>
                                            <MenuItem value={1}> Own</MenuItem>
                                            <MenuItem value={2}> Hired</MenuItem>
                                            <MenuItem value={3}> Other</MenuItem>
                                        </TextField>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            label="Other Transportation of Produce *"
                                            value={formik.values.TransOther}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('TransOther')}
                                            error={Boolean(touched.TransOther && errors.TransOther)}
                                            helperText={touched.TransOther && errors.TransOther}
                                            disabled={factoryType == 1 || factoryType == 3 || formik.values.Transportation !== 3}
                                        />

                                    </Stack>
                                    {/* <br /> */}
                                    {/* <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        <Grid item xs={4} sm={4} md={4}>
                                            <TextField select
                                                fullWidth
                                                size="small"
                                                label="Type of the Vehicle *"
                                                value={formik.values.TypeOfTheVehicle}
                                                onChange={(event) => {
                                                    formik.handleChange(event);
                                                    // Check if the selected value is 'Other' to enable/disable the other text field
                                                    if (event.target.value === 9) {
                                                        formik.setFieldValue('TypeOfTheVehicleOther', '');
                                                    }
                                                }}
                                                {...getFieldProps('TypeOfTheVehicle')}
                                                error={Boolean(touched.TypeOfTheVehicle && errors.TypeOfTheVehicle)}
                                                helperText={touched.TypeOfTheVehicle && errors.TypeOfTheVehicle}
                                                disabled={factoryType == 1 || factoryType == 3}
                                            >
                                                <MenuItem key={0} value={0}> Select Type of the Vehicle </MenuItem>
                                                <MenuItem value={1}> Motor Bike</MenuItem>
                                                <MenuItem value={2}> Three Wheeler</MenuItem>
                                                <MenuItem value={3}> Car</MenuItem>
                                                <MenuItem value={4}> SUV</MenuItem>
                                                <MenuItem value={5}> Van</MenuItem>
                                                <MenuItem value={6}> Truck</MenuItem>
                                                <MenuItem value={7}> Tractor</MenuItem>
                                                <MenuItem value={8}> Land Master</MenuItem>
                                                <MenuItem value={9}> Other</MenuItem>
                                            </TextField>
                                        </Grid>
                                        <Grid item xs={4} sm={4} md={4}>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Other Type of Vehicle *"
                                                value={formik.values.TypeOfTheVehicleOther}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('TypeOfTheVehicleOther')}
                                                error={Boolean(touched.TypeOfTheVehicleOther && errors.TypeOfTheVehicleOther)}
                                                helperText={touched.TypeOfTheVehicleOther && errors.TypeOfTheVehicleOther}
                                                disabled={factoryType == 1 || factoryType == 3 || formik.values.TypeOfTheVehicle !== 9}
                                            />
                                        </Grid>
                                        <Grid item xs={4} sm={4} md={4}>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Vehicle Number *"
                                                value={formik.values.VehicalNumber}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('VehicalNumber')}
                                                error={Boolean(touched.VehicalNumber && errors.VehicalNumber)}
                                                helperText={touched.VehicalNumber && errors.VehicalNumber}
                                                disabled={factoryType == 1 || factoryType == 3}
                                            />
                                        </Grid>
                                    </Stack> */}
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        <Grid item xs={4} sm={4} md={4}>
                                            <TextField select
                                                fullWidth
                                                size="small"
                                                label="Labour Used * "
                                                value={formik.values.LabourType}
                                                onChange={(event) => {
                                                    formik.handleChange(event);

                                                    // Check if the selected value is 'Other' to enable/disable the other text field
                                                    if (event.target.value === 4) {
                                                        formik.setFieldValue('OtherLabourType', '');
                                                    }
                                                }}
                                                {...getFieldProps('LabourType')}
                                                error={Boolean(touched.LabourType && errors.LabourType)}
                                                helperText={touched.LabourType && errors.LabourType}
                                                disabled={factoryType == 1 || factoryType == 3}
                                            >
                                                <MenuItem key={0} value={0}> Select Labour Used</MenuItem>
                                                <MenuItem value={1}> Family</MenuItem>
                                                <MenuItem value={2}> Hired-Permanent</MenuItem>
                                                <MenuItem value={3}> Hired-Casual</MenuItem>
                                                <MenuItem value={4}> Other</MenuItem>
                                                <MenuItem value={5}> None</MenuItem>
                                            </TextField>
                                        </Grid>
                                        <Grid item xs={4} sm={4} md={4}>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Other Labour Used *"
                                                value={formik.values.OtherLabourType}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('OtherLabourType')}
                                                error={Boolean(touched.OtherLabourType && errors.OtherLabourType)}
                                                helperText={touched.OtherLabourType && errors.OtherLabourType}
                                                disabled={factoryType == 1 || factoryType == 3 || formik.values.LabourType !== 4}
                                            />
                                        </Grid>
                                        <Grid item xs={4} sm={4} md={4}></Grid>
                                    </Stack>
                                    <br />
                                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                        <LoadingButton
                                            size="medium"
                                            type="button"
                                            variant="outlined"
                                            color='error'
                                            onClick={() => clearAll()}
                                            disabled={pageProps.Edit || factoryType == 1 || factoryType == 3}
                                        >
                                            Clear
                                        </LoadingButton>
                                        <LoadingButton
                                            size="medium"
                                            type="submit"
                                            variant="outlined"
                                            color='secondary'
                                            disabled={factoryType == 1 || factoryType == 3}
                                        >
                                            {pageProps.submitButtonName}
                                        </LoadingButton>
                                    </Stack>
                                </Stack>
                                <br />
                                <Divider />
                                <br />
                                <Card>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        {(SupplierProduceArray.length > 0) ?
                                            <Grid item xs={12}>
                                                <TableContainer >
                                                    <Table style={{ minWidth: 850 }} aria-label="caption table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell align="center">Brands Supplied</TableCell>
                                                                <TableCell align="center">Other Buyers of Agri Produce</TableCell>
                                                                <TableCell align="center">Name of Entity</TableCell>
                                                                <TableCell align="center">Transportation of Produce</TableCell>
                                                                <TableCell align="center">Labour Used</TableCell>
                                                                {(factoryType == 1 || factoryType == 3) ? null :
                                                                    <TableCell align="center">Action</TableCell>}
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {SupplierProduceArray.map((rowData, index) => (
                                                                <TableRow key={index}>
                                                                    <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                        {rowData.brandOfSupplied == 1
                                                                            ? 'Good Harvest'
                                                                            : rowData.brandOfSupplied == 2
                                                                                ? 'Bee Safe'
                                                                                : rowData.brandOfSupplied == 3
                                                                                    ? 'Normal'
                                                                                    : '-'
                                                                        }
                                                                    </TableCell>
                                                                    <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                        {rowData.buyersOfAgriProduceType == 1
                                                                            ? 'Wet Market'
                                                                            : rowData.buyersOfAgriProduceType == 2
                                                                                ? 'Exporter'
                                                                                : rowData.buyersOfAgriProduceType == 3
                                                                                    ? 'Other Super Markets'
                                                                                    : rowData.buyersOfAgriProduceType == 4
                                                                                        ? 'Other'
                                                                                        : '-'
                                                                        }
                                                                    </TableCell>
                                                                    <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                        {rowData.nameOfEntity == null ? '-' : rowData.nameOfEntity}
                                                                    </TableCell>
                                                                    <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                        {rowData.transportation == 1
                                                                            ? 'Own'
                                                                            : rowData.transportation == 2
                                                                                ? 'Hired'
                                                                                : rowData.transportation == 3
                                                                                    ? 'Other'
                                                                                    : '-'
                                                                        }
                                                                    </TableCell>
                                                                    <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                        {rowData.labourType == 1
                                                                            ? 'Family'
                                                                            : rowData.labourType == 2
                                                                                ? 'Hired-Permanent'
                                                                                : rowData.labourType == 3
                                                                                    ? 'Hired-Casual'
                                                                                    : rowData.labourType == 4
                                                                                        ? 'Other'
                                                                                        : 'None'
                                                                        }
                                                                    </TableCell>
                                                                    {(factoryType == 1 || factoryType == 3) ? null :
                                                                        <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                            {pageProps.Edit != true ?
                                                                                <Tooltip title="Edit">
                                                                                    <IconButton
                                                                                        variant="outlined"
                                                                                        onClick={() => handleEdit(rowData, index)}>
                                                                                        <EditIcon />
                                                                                    </IconButton>
                                                                                </Tooltip> : null}
                                                                            <Tooltip title="Delete">
                                                                                <IconButton
                                                                                    variant="outlined"
                                                                                    color="error"
                                                                                    onClick={() => handleConfirm(index)}>
                                                                                    <DeleteIcon />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        </TableCell>}
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Grid>
                                            : null}
                                    </Stack>
                                </Card>
                            </Card>
                        </Form>
                    </FormikProvider>
                </Container>
                <div hidden={true}>
                    <Grid item>
                        <AlertDialog confirmData={confirmData} headerMessage={message} viewPopup={EnableConfirmMessage}
                            discription={"Are you sure want to delete Supplier Produce details ?"} setViewPopup={setEnableConfirmMessage} />
                    </Grid>
                </div>
            </Page >
        </>
    )
}